// extracted by mini-css-extract-plugin
export default {"subTitle":"styles_subTitle__lG+AP","spanLeft":"styles_spanLeft__dX-k1","mL30":"styles_mL30__oGV3z","mL60":"styles_mL60__x-RnQ"};